import { render } from "./Check.vue.js?vue&type=template&id=5fc883a1!=!../vue-loader/dist/index.js??ruleSet[0]!./Check.vue?vue&type=template&id=5fc883a1"
import script from "./Check.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Check.vue?vue&type=script&lang=js"
export * from "./Check.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Check.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__